// import React, { useState, useEffect } from 'react';

import Navigation from '../Navigation/Navigation';
// import Brands from './Brands';
// import PlacementData from '../Data/PlacementData';
import HomeData from '../Data/HomeData';
// import BrandsBanner from '../Tools/BrandsBanner';

import BANNER from '../../Images/andybackground.jpeg';
import Arrow from '../../Images/arrow-right-circle.svg';

import './Landing.css';

// const BANNER = 'https://images.pexels.com/photos/167699/pexels-photo-167699.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
// const BANNER = 'https://images.pexels.com/photos/1529881/pexels-photo-1529881.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';

// const score = 'https://images.pexels.com/photos/104084/pexels-photo-104084.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
// const studio = 'https://images.pexels.com/photos/185030/pexels-photo-185030.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
// const theatre = 'https://images.pexels.com/photos/4722577/pexels-photo-4722577.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';

const Landing = ({navigate,dimensions,width}) => {
	// const [ selection, setSelection ] = useState(0);

	// useEffect(()=>{
	// 	let num = 0;
	// 	const interval = setInterval(()=>{
	// 		num+=1;
	// 		setSelection(num%HomeData.length);
	// 	}, 6000);
	// 	return()=>{
	// 		clearInterval(interval)
	// 	}
	// },[]);



	let bottomStripHigh = 240;
	if(dimensions.width < 600) bottomStripHigh = 180;
	function bottomStrip() {
		let arr = [];
		for(let i = 0; i < HomeData.length; i++){
			arr.push(
				<div key={i} style={{width:bottomStripHigh-20,height:bottomStripHigh-20,borderRadius:5,marginTop:10,marginBottom:10,marginLeft:10,
						overflow:'hidden'}} className='flexCenter'>
					<img src={HomeData[i].thumbnail} alt='placement' style={{width:`${104*HomeData[i].thumbPos.size-4}%`,
							marginTop:HomeData[i].thumbPos.t*(dimensions.width/(dimensions.width+0.01)),
							marginLeft:HomeData[i].thumbPos.l*(dimensions.width/(dimensions.width+80))}}
							className='pointer hoverOpacityDown' onClick={()=>{navigate(HomeData[i].navigation)}} />
				</div>
			)
		}
		arr.push(
			<div key={'12s'} style={{width:HomeData.length*10,height:bottomStripHigh-20,marginTop:10,marginBottom:10,marginLeft:10}}
					className='flexCenter'>
				<img src={Arrow} alt='placement' style={{width:'60%'}} className='pointer hoverOpacityUp' onClick={()=>{navigate('/film')}} />
			</div>
		)
		return(
			<div className='' style={{overflow:'scroll',background:'rgb(50,50,50)'}}>
				<div className='flexHeightCenter' style={{width:bottomStripHigh*HomeData.length+20}}>{arr}</div>
			</div>
		)
	}


	if(dimensions.width < 600){
		return(
			<div>
				<Navigation navigate={navigate} width={width} opacity={0} />
				{/*<div style={{height:60}}></div>*/}

				<div style={{height:dimensions.height-bottomStripHigh,width:dimensions.width,overflow:'hidden',zIndex:10,
						backgroundImage:'linear-gradient(to right, rgba(0,0,0,0),rgba(0,0,0,0.9))',textShadow:'0px 0px 7px rgba(0,0,0,0.5)',
						color:'white'}} className='flexCenter absolute'>
					<div style={{width:width,height:'100%'}} className='flexCenter flexRight'>
						{dimensions.width < 460
							? <div style={{width:(dimensions.width-20),textAlign:'right'}}>
								<div className='heroText bold' style={{marginBottom:12}}>Andy Marsh</div>
								<div className='heading boldX flexRight'><div style={{background:'rgba(255,255,255,0.4)',marginRight:6,paddingLeft:4,paddingRight:4}}>Composer</div></div>
								<div className='heading boldX flexRight' style={{marginTop:6}}><div style={{background:'rgba(255,255,255,0.4)',marginRight:6,paddingLeft:4,paddingRight:4}}>Songwriter</div></div>
								<div style={{height:20}}></div>
							</div>
							: <div style={{width:420,textAlign:'right'}}>
								<div className='heroText bold' style={{marginBottom:12}}>Andy Marsh</div>
								<div className='heading boldX flexRight'><div style={{background:'rgba(255,255,255,0.4)',marginRight:6,paddingLeft:4,paddingRight:4}}>Composer</div> of music for film & TV</div>
								<div className='heading boldX flexRight' style={{marginTop:6}}><div style={{background:'rgba(255,255,255,0.4)',marginRight:6,paddingLeft:4,paddingRight:4}}>Songwriter</div> for artists & brands</div>
								<div style={{height:20}}></div>
							</div>
						}
						{/*<div style={{width:20}}></div>*/}
					</div>
				</div>
				<div style={{height:dimensions.height-bottomStripHigh,width:dimensions.width,zIndex:2,overflow:'hidden'}} className='flexCenter relative'>
					{dimensions.width*0.6 < dimensions.height
						? <img src={BANNER} alt='BANNER' style={{height:'124%',}} />
						: <img src={BANNER} alt='BANNER' style={{height:'124%',}} />
					}
				</div>
				{bottomStrip()}
				{/*<div style={{background:'black',height:76}} className='flexCenter'>
					<BrandsBanner dimensions={dimensions} />
				</div>*/}
			</div>
		)
	}
	return(
		<div>
			<Navigation navigate={navigate} width={width} opacity={0} />
			{/*<div style={{height:60}}></div>*/}

			<div style={{height:dimensions.height-bottomStripHigh,width:dimensions.width,overflow:'hidden',zIndex:10,
					backgroundImage:'linear-gradient(to right, rgba(0,0,0,0),rgba(0,0,0,0.9))'}} className='flexCenter absolute'>
				{/*<div className=''>*/}
					<div style={{textAlign:'right',color:'white',textShadow:'0px 0px 7px rgba(0,0,0,0.5)',width:width,height:'100%'}} className=' flexCenter flexRight'>
						<div>
							<div className='heroText2 bold' style={{marginBottom:18}}>Andy Marsh</div>
							<div className='heading boldX flexRight'><div style={{background:'rgba(255,255,255,0.4)',marginRight:6,paddingLeft:4,paddingRight:4}}>Composer</div> of music for film & TV</div>
							<div className='flexRight' style={{marginTop:6}}>
								<div className='heading boldX flexRight' style={{width:530,textAlign:'right'}}><div style={{background:'rgba(255,255,255,0.4)',marginRight:6,paddingLeft:4,paddingRight:4}}>Songwriter</div> for artists & brands</div>
							</div>
							<div style={{height:42}}></div>
						</div>
					</div>
					<div style={{width:42}}></div>
				{/*</div>*/}
			</div>

			{dimensions.width*1.18 < dimensions.height
				? <div style={{height:dimensions.height-bottomStripHigh,width:dimensions.width,zIndex:2,overflow:'hidden'}} className='flexCenter relative'>
					<img src={BANNER} alt='BANNER' style={{height:'142%',}} />
				</div>
				: <div style={{height:dimensions.height-bottomStripHigh,width:dimensions.width,zIndex:2,overflow:'hidden'}} className='flexHeightCenter flexRight relative'>
					<img src={BANNER} alt='BANNER' style={{width:'142%',}} />
				</div>
			}
			

			{bottomStrip()}

			{/*<div style={{background:'black',height:76}} className='flexCenter'>
				<BrandsBanner dimensions={dimensions} />
			</div>*/}

		</div>
	)
}

export default Landing;